<h1 mat-dialog-title>{{ data.modalTitle }}</h1>
<mat-dialog-content id="dataToPrint">
  <div class="row">
    <table>
      <tr>
        <td style="width:15%">
          <div class="print-title">{{ 'balances.fields.detail.code' | translate }}</div>
        </td>
        <td style="width:40%">
          <div class="print-title">{{ 'balances.fields.detail.description' | translate }}</div>
        </td>
        <td style="width:15%; text-align:right">
          <div class="print-title">{{ 'balances.fields.detail.quantity' | translate }}</div>
        </td>
        <td style="width:15%; text-align:right">
          <div class="print-title">{{ 'balances.fields.detail.unitPrice' | translate }}</div>
        </td>
        <td style="width:15%; text-align:right">
          <div class="print-title">{{ 'balances.fields.detail.totalRow' | translate }}</div>
        </td>
      </tr>
      <tr *ngFor="let item of data.detail">
        <td style="width:15%">
          {{ item.code }}
        </td>
        <td>
          {{ item.description }}
        </td>
        <td style="width:15%; text-align:right">
          {{ item.quantity }}
        </td>
        <td style="width:15%; text-align:right">
          {{ item.unitPrice }}
        </td>
        <td style="width:15%; text-align:right">
          {{ item.totalRow }}
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content> <!-- mat-dialog-content -->

<div class="row w-100 mt-5" mat-dialog-actions>
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default class="ml-3">{{ 'common.cta.close' | translate
      }}</a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <a mat-button (click)="onPrint()" mat-raised-button mat-default class="ml-3" color="primary">
      {{ 'common.cta.print' | translate }}
      <mat-icon fontSet="fal" fontIcon="fa-print"></mat-icon>
    </a>
  </div> <!-- /.col -->
</div> <!-- /.row -->